export default __webpack_public_path__ + "static/media/Logo_Primario_Indigo.22227deb.png";